  $(document).ready(function() {
 $(".customsubmits").click(function(){
    RechargeCartSubmit();
});
  	  if ( $('.scroll-to-up').length) { 
	  var scrollShow = 0;
        window.addEventListener('scroll', scrollToUp);
        function scrollToUp() {
            var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var height = h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;            

            if (winScroll > height) {
              if (!scrollShow) {
                scrollShow = 1
                $( ".scroll-to-up" ).animate({ opacity: 1}, 100, function() { });
              }
            }else{
              if (scrollShow) {
                scrollShow = 0
                $( ".scroll-to-up" ).animate({ opacity: 0}, 100, function() { });
              }
            }         
        }
    }
     if ($(window).width() < 1025 ) {
        $('.collections-slider').not('.slick-initialized').slick({

          draggable:true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }    

          ]
        });
     }
    /* $('.slider-say-text').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true, 
       infinite:false

      });

      $('.slider-say').slick({

          centerPadding: '20px',
          slidesToShow: 5,
          draggable:true,        
          slidesToScroll: 1,
          centerMode: true,
          focusOnSelect: false,
          asNavFor: '.slider-say-text',
        speed: 300,
        arrows: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '10px',
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '10px',
                slidesToShow: 1
              }
            }
          ]
        });
        */
    /*
       $('.slider-home-2').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,      
        infinite:false,
        dots: true      
      });
    */


    /*
      if (hash == "#parentHorizontalTab2") {
        var top = document.getElementById("Interface").offsetTop; //Getting Y of target element
        window.scrollTo(0, top);

      } else if (hash == "#parentHorizontalTab3") {
        //select tab 3 etc
      }
      var scrollName = $(this).attr('data-scroll'),
      scrollElem = $(scrollName),
      scrollTop = scrollElem.offset().top;

      $('html, body').animate({
        scrollTop: scrollTop
      }, 500);
    */
    $(document).on('click', '.custom-scroll', function (event) {
        event.preventDefault();
      	let hash = $.attr(this, 'href');
      
        if ($(hash).parent().hasClass('tab-pane')){
          let parentId = $(hash).parent().attr('id');
          $('.nav-tabs a[href="#' + parentId + '"]').tab('show');
        }

        if ($(hash).parent().hasClass('tab--big-pane')){
          $('.page-product-block').removeClass('active-block');
          $(hash).parents('.page-product-block').addClass('active-block');       
        }
      if (!$(document).find(hash).offset().top){
      	
        setTimeout(function() {
          let cur = $(document).find(hash)
          $('html, body').animate({
              scrollTop: cur.offset().top-100
          }, 500);
        }, 200);
      }else{
         let cur = $(document).find(hash)
          $('html, body').animate({
              scrollTop: cur.offset().top-100
          }, 500);
      }
    });
    $(document).on('click', '.custom-nav-tab', function (event) {
    	$('.custom-nav-tab').removeClass('active-header');
      	$(this).parent().find('.tab-pane').removeClass('active').removeClass('show').hide();
      	$(this).addClass('active-header');
      	let cl = $(this).attr('data-id');     
      	
         $('html, body').animate({
          scrollTop: $('#myTabContent').offset().top      	
        }, 100); 
        $("#"+cl).slideToggle( "fast", function() {
          $("#"+cl).addClass('active').addClass('show');
        });
      	
    })
    $('.menu-btn').on('click', function(){
     
        if($('#menu-toggle').is(":checked")){
           
          $('body').removeClass('menu-open');
        }else{
           
          $('body').addClass('menu-open');
        }
      
    })
    $('.slider-say').on('beforeChange', function(event, slick, direction){
      $(this).find('.active-item').removeClass('active-item');

    });
    $('.slider-say').on('afterChange', function(event, slick, direction){

      $(this).find('.slick-active').eq( 2 ).addClass('active-item');
    });
    $('.slider-say').on('setPosition', function(event, slick, direction){


    });
    purchaseType = $('[name="purchase_type"]:checked').val();

    $('[name="purchase_type"]').on('click', function(event){
      let curType = $(this).val();
      if (purchaseType !=  curType) {
        $('[data-sub]').each(function( index ) {
          let hrefAttr = $(this).attr('href');      	
          let newLink = $(this).attr('data-sub');
          let curLink

          if (typeof hrefAttr !== typeof undefined && hrefAttr !== false) {
            curLink = hrefAttr;
            $(this).attr('href',newLink);
          }else{
            curLink = $(this).attr('data-href');
            $(this).attr('data-href',newLink);
          }

          $(this).attr('data-sub',curLink);
        });
        purchaseType = curType;
      }

    });
    if ($('.product-single-photo').length) {     
      activateSlickInProd();
    }  
    if ($('.page-faq').length && $('.page-faq').find('.item').length) {
      $('.about-tab').show();
    }

    if ($('#how_work').length && $('#how_work').find('section').length) {
      $('.how_work-tab').show();
    }
    if ($('.prod-slider').length) {  
      $('.prod-slider').not('.slick-initialized').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable:true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }    

        ]
      });
    }
    if ($('.product-panel-bottom').length && $('#show-bottom-panel').length) {  
      var $document = $(document);
      $document.on('scroll', function (e) {
        var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
		let startTop = $('#show-bottom-panel').offset().top;
        //console.log(startTop);
		if ((scrollTop > startTop)) {
           $('.product-panel-bottom').css('display', 'flex');
          $('body').addClass('hideextrapop');
        }
        else {
          $('.product-panel-bottom').hide();
          $('body').removeClass('hideextrapop');
        }

      })
      // When the user clicks on the button, scroll to the top of the document
      function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    }
    $(document).on('click', '.carousel-review-body', function (event) {      
      
     // $(this).find('.carousel-read-more').remove();
    });
    $(document).find('.carousel-review-body').each(function() {
    	
      //	$(this).find('.carousel-read-more').unbind();
    });
    
    if ($('.carousel-read-more').length) {
      //console.log('123');
      
      $('.carousel-read-more').removeClass('.carousel-read-more').addClass('carousel-read-more-custom');
      
    }
    
    
    
    $('.singleflavour').click(function(){
    var get_optval = $(this).data('val');
    var get_image = $(this).find('img').attr('src');
    $('.singleflavour').removeClass('active');
    $(this).addClass('active');
      $('.product-single__thumbnails .product-single__thumbnails-item').each(function(){
        if ($(this).find('img').attr('src').indexOf(get_image) >= 0){
        var slideIndex = $(this).data('slick-index');
        $('.init_slick_slider').slick('slickGoTo', slideIndex);
        }
      });
      
      
      if($(this).data('index') == 1){
      $('.enablemultvairant').each(function(){
      var get_optid = $(this).data('firstid');
      $(this).find('button.btn-now').attr('onclick','addNewProdCart(event,'+get_optid+')');
      $(this).attr('id','block-'+get_optid);
      });
      }else{
      $('.enablemultvairant').each(function(){
      var get_optid = $(this).data('secondid');
      $(this).find('button.btn-now').attr('onclick','addNewProdCart(event,'+get_optid+')');
      $(this).attr('id','block-'+get_optid);
      });
      }
      
      
    });
  });


window.onload = function () {
  var hash = window.location.hash;
  if (hash && $(hash).length){
    
    if ($(hash).parent().hasClass('tab-pane')){
      let parentId = $(hash).parent().attr('id'); 
      
      $('.nav-tabs a[href="#' + parentId + '"]').tab('show');
    }
    
    if ($(hash).parent().hasClass('tab--big-pane')){
      $('.page-product-block').removeClass('active-block');
     
      $(hash).parents('.page-product-block').addClass('active-block');       
        
    }

    setTimeout(() =>  {
        $('html, body').animate({
          scrollTop: $(hash).offset().top      	
        }, 100);    	
      }, 500);
  //console.log('scroll');


  }
function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*60*60*1000)); //h add 24* to days
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  var forCarthook = location.search.substr(1);

  if (forCarthook && forCarthook.indexOf("sub1=") > -1 ) {
    setCookie("url_param",forCarthook , 1);
  }


  $('.rc_label__onetime .rc_custom_button').click(function(){   
    $('.change-variant-script').each(function(){
      let price = parseInt($(this).attr('data-priceper'));
      if (price) {
        let oneSum = $(this).find('.save-sum').attr('data-onesum');
        if(oneSum == 0){
        $(this).find('.save-text').addClass('tetrahide');
        }

        $(this).find('.save-sum').html(oneSum);
        $(this).find('.total-price').find('span').html($(this).attr('data-price'));
       // $(this).find('.old-price').find('span').html($(this).attr('old-price'));
        $(this).find('.change-variant-price').find('strong').html(price.toFixed(0));
        $(this).find('.change-variant-price').find('.drop').html('00'); 
        $(this).attr('data-origprice', $(this).attr('data-fullprice'));
      }
    });
  $('.add-description').hide( "fast");
     if (!$(this).parents('.rc_block').hasClass('rc_block__type--active'))
        {
          
          // afterpay block
          if (typeof info_produts !== 'undefined') {

            let url = $('.variant-prod').val();
            if (info_produts.hasOwnProperty(url)) {
              if (typeof afterpay_product !== 'undefined' ) {
                afterpay_product = info_produts[url];
                $('.afterpay-paragraph').attr('data-product-id',info_produts[url].id);
                //$('form[action^="/cart/add"]').change();
                let price = $('#block-'+url).attr('data-fullprice');
                
                if (price && price > 3000) {
                  $('.afterpay-instalments').html(Afterpay.generateInstalmentHTML(price));
                  setTimeout(() => $('.afterpay-paragraph').show(), 50);
                 
                }else{
                  $('.afterpay-instalments').html('');
                  setTimeout(() => $('.afterpay-paragraph').hide(), 50);
                }

              }
            }
          }
          // end afterpay 
  		}

  })

  $('.rc_label__autodeliver .rc_custom_button').click(function(){
    $('.change-variant-script').each(function() {
      let price = parseInt($(this).attr('data-pricePer')) - parseInt($(this).attr('data-pricePer'))*(parseInt($(this).attr('data-percentage'))/100);
      if (price) {
        
        let inPrice = price.toFixed(0);
        let getoriginal = parseInt($(this).data('priceper'));
        //let dropPrice = (price + '').split ('.') [1];
        let oneSum = parseInt($(this).find('.save-sum').attr('data-onesum'));
        if(oneSum == 0){
        $(this).find('.save-text').removeClass('tetrahide');
        }
        let subSum = oneSum + getoriginal*(parseInt($(this).attr('data-percentage'))/100);
        if (subSum) {
          $(this).find('.save-sum').html(Math.round(subSum));
        }
        $(this).find('.change-variant-price').find('strong').html(inPrice);
        $(this).find('.change-variant-price').find('.drop').html('00');//.html(dropPrice);
      }
      let procentage = parseInt($(this).attr('data-fullprice')) - parseInt($(this).attr('data-fullprice'))*(parseInt($(this).attr('data-percentage'))/100);
      
      $(this).attr('data-origprice', procentage);     
      
      
      $(this).find('.total-price').find('span').html($(this).attr('data-discord'));
      //$(this).find('.old-price').find('span').html($(this).attr('old-price'));
      
    });
    $('.add-description').show("fast");
    
    if (!$(this).parents('.rc_block').hasClass('rc_block__type--active'))
        {
          
            setTimeout(() => $('.afterpay-paragraph').hide(), 50);  
    		// afterpay block
    		/*if (typeof info_produts !== 'undefined') {

              let url = $('.variant-prod').val();
              if (info_produts.hasOwnProperty(url)) {
                if (typeof afterpay_product !== 'undefined' ) {

                  $('.afterpay-paragraph').attr('data-product-id',info_produts[url].id);

                  let price = $('#block-'+url).attr('data-origprice');          
                  if (price) {
                    // info_produts[url].price = price;
                    afterpay_product = info_produts[url];
                    
                    $('.afterpay-paragraph').attr('data-product-id',info_produts[url].id);
                    
                    
                    if (info_produts[url].price > 3000) {
                      $('.afterpay-instalments').html(Afterpay.generateInstalmentHTML(price));
                      setTimeout(() => $('.afterpay-paragraph').show(), 100);
                    }else{
                      $('.afterpay-instalments').html('');
                      setTimeout(() => $('.afterpay-paragraph').hide(), 100);
                    }
                }
              }
            }     
          }
          */
     // end afterpay
  	}
  })
setTimeout(function(){
$('.rc_label__autodeliver .rc_custom_button').trigger('click');
  }, 1000);

  
};
var addCartLink = '';
var purchaseType;
var firstClick = 0;
  function addNewProd(url,callback) {
    if (!url) return;    
    let curSrc = $('#block-'+url).find('.variant-img').attr('data-src');
    let sale = $('#block-'+url).attr('data-price'); 
    let price = $('#block-'+url).attr('data-compare');
    let pricePer = parseInt($('#block-'+url).attr('data-pricePer'));
    let percentage = parseInt($('#block-'+url).attr('data-percentage'));
    let shipping = $('#block-'+url).attr('data-shipping');
    let imgText =  $('#block-'+url).attr('data-imgtext'); 
    let imgTextColor =  $('#block-'+url).attr('data-imgtextcolor'); 
    let imgTextBot =  $('#block-'+url).attr('data-imgtext-bot'); 
    let handle =  $('#block-'+url).attr('data-href');
    let title = $('#block-'+url).attr('data-title');
    
    let linkBuyNow = $('[data-other-handle="'+handle+'"]').attr('data-href');  
    let linkSubBuyNow = $('[data-other-handle="'+handle+'"]').attr('');  
    
    
    let frequency = $('#block-'+url).attr('data-frequency');
    let unit = $('#block-'+url).attr('data-unit-type');
    
    

    
    // afterpay block
    let purchaseType = $('[name="purchase_type"]:checked').val();    
    if ( purchaseType == 'autodeliver') {
      setTimeout(() => $('.afterpay-paragraph').hide(), 50);
    }else{
      if (typeof info_produts !== 'undefined' ) {

        if (info_produts.hasOwnProperty(url)) {

          if (typeof afterpay_product !== 'undefined' ) {

            afterpay_product = info_produts[url];
            $('.afterpay-paragraph').attr('data-product-id',info_produts[url].id);
            //$('form[action^="/cart/add"]').change();         	


            if (info_produts[url].price > 3000) {
             $('.afterpay-instalments').html(Afterpay.generateInstalmentHTML($('#block-'+url).attr('data-origprice')));
              setTimeout(() => $('.afterpay-paragraph').show(), 50);              
            }else{
               $('.afterpay-instalments').html('');
              setTimeout(() => $('.afterpay-paragraph').hide(), 50);
            }

          }
        }
      }
    }
    // end afterpay
    
   // why-period
    if (frequency && unit) {
      $('.why-period').html(frequency+ ' ' + unit);
    }
    
    $('.variant-prod').val(url); 
    $('.variant-prod').attr("data-productid",$('#block-'+url).attr('data-prodid'));
    $('.product-form').attr("data-productid",$('#block-'+url).attr('data-prodid'));
    $('.sellify-ucd-cart-form').attr("data-productid",$('#block-'+url).attr('data-prodid'));
    
    //$('.rc_radio__'+purchaseType).click();
    $('.rc_block__type--active').click();
    if (firstClick) {
      $('.button-list-script').removeClass('active-block');
      $('.change-variant-script').removeClass('active-block');
      $('#block-'+url).addClass('active-block');
      
    }
	firstClick++;
    
    if (linkBuyNow){     
      $('.btn-now a').attr('href',linkBuyNow);
    }
    
	if (frequency){
     // console.log($('[name=properties[shipping_interval_frequency]]'));
       $('select[name*=shipping_interval_frequency]').find('option').remove();
      $('select[name*=shipping_interval_frequency]').append('<option value="'+frequency+'">'+frequency+ ' ' + unit+'</option')
      $('select[name*=shipping_interval_frequency]').val(frequency);
      $('.rc_label__deliver_every').find('.rc_label__frequency').html(frequency+ ' ' + unit);
    }
    if (unit) {
      $('input[name*=shipping_interval_frequency]').val(unit);
    }
    
    //console.log(linkBuyNow);
    if (shipping == 'true') {
      $('.shipping-free').show();
      $('.shipping-block').hide();
      
    }else{
      $('.shipping-free').hide();
      $('.shipping-block').show();
    }
    
    if (imgText != '') {
      $('.img-text').html(imgText).removeClass('text-white text-black').addClass(imgTextColor);
      
    }else{
      $('.img-text').html('').removeClass('text-white text-black');
    }
  
    //relate on version
    if (temp_version != '2-1') { 
      if (title) {      
          $('.product-single__title').html(title);
      }

      if (imgTextBot != '') {
        $('.img-text-bot').html(imgTextBot);
      }else{
        $('.img-text-bot').html('');
      }

      if ($('.button-list-script').find('.change-variant-script').length) {

        if ($('.thumbnails-wrapper').length) {
          $('.thumbnails-wrapper').remove(); 
        }
        if ($('#block-'+url).find('.variant-img1').length) {

          $('.product-single-photo').append('<div class="thumbnails-wrapper"><ul class="product-single__thumbnails"></ul></div>');
          let imgHref = '<a href="'+$('#block-'+url).find('.variant-img').attr('data-src')+'" class="text-link product-single__thumbnail active-thumb" data-thumbnail-id="product-template-'+$('#block-'+url).find('.variant-img').attr('data-id')+'" aria-current="true"><img class="product-single__thumbnail-image" data-slick="'+$('#block-'+url).find('.variant-img').attr('data-slick')+'" src="'+$('#block-'+url).find('.variant-img').attr('data-small')+'" data-small="'+$('#block-'+url).find('.variant-img').attr('data-small')+'" alt=""></a>';
          $('.product-single__thumbnails').append('<li class="product-single__thumbnails-item product-single__thumbnails-item--medium js">'+imgHref+'</li>');


          imgHref = '<a href="'+$('#block-'+url).find('.variant-img1').attr('data-src')+'" class="text-link product-single__thumbnail " data-thumbnail-id="product-template-'+$('#block-'+url).find('.variant-img1').attr('data-id')+'" aria-current="true"><img class="product-single__thumbnail-image" data-slick="'+$('#block-'+url).find('.variant-img1').attr('data-slick')+'" src="'+$('#block-'+url).find('.variant-img1').attr('data-small')+'" data-small="'+$('#block-'+url).find('.variant-img1').attr('data-small')+'" alt=""></a>';
          $('.product-single__thumbnails').append('<li class="product-single__thumbnails-item product-single__thumbnails-item--medium js">'+imgHref+'</li>');

          if ($('#block-'+url).find('.variant-img2').length) {

            imgHref = '<a href="'+$('#block-'+url).find('.variant-img2').attr('data-src')+'" class="text-link product-single__thumbnail " data-thumbnail-id="product-template-'+$('#block-'+url).find('.variant-img2').attr('data-id')+'" aria-current="true"><img class="product-single__thumbnail-image" data-slick="'+$('#block-'+url).find('.variant-img2').attr('data-slick')+'" src="'+$('#block-'+url).find('.variant-img2').attr('data-small')+'" data-small="'+$('#block-'+url).find('.variant-img2').attr('data-small')+'" alt=""></a>';
            $('.product-single__thumbnails').append('<li class="product-single__thumbnails-item product-single__thumbnails-item--medium js">'+imgHref+'</li>');

          }
          activateSlickInProd();
        }	

      }
      $('.product-single__media').find('img').attr('srcset','').attr('src',curSrc);
    }
    
    if (temp_version == '2-1') { 
       activateSlickInProd();
    }
   /* 
    $('.product-single__media').find('img').animate({
       opacity: 0, 
    },100, "linear", function(){
      $( this ).attr('srcset','').attr('src',curSrc);
      $( this ).animate({
        opacity: 1,
      },100, "linear", function() {        
      });
    });
    */

    $('.price-item--sale').text(sale);
    $('.price-item--regular').text(price);
    
    if (callback) {
      callback();
    }

    return true;

}
function togleHealth(obj){


  
  
  
      $(document).ready(function() {
        
        let curentObj = obj;

        let countInRow = parseInt($(obj).parent().attr('data-number'));
        let countTotalArr = parseInt($(obj).parent().attr('data-id'));
   		if ($(window).width() < 992) {
              if ($(obj).hasClass('block-open')) {
              		
                  $(obj).removeClass('block-open');
              	  $(obj).parent().find('.health-text').hide();
                }else{
                  $(obj).addClass('block-open');
                  $(obj).parent().find('.health-text').slideDown('fast');
          		}
        }else{
          if (countInRow == 1) {
            if ($(obj).hasClass('block-open')) {
              		
                  $(obj).removeClass('block-open');
              	  $(obj).parent().find('.health-text').hide();
            	  
            	  if ($('#pos-'+(countTotalArr+1)).length) {
                    $('#pos-'+(countTotalArr+1)).find('.block-head ').removeClass('block-open'); 
                    $('#pos-'+(countTotalArr+1)).find('.health-text').hide()
                  }
                }else{
                  $(obj).addClass('block-open');
                  $(obj).parent().find('.health-text').slideDown('fast');                  
                  if ($('#pos-'+(countTotalArr+1)).length) {
                    $('#pos-'+(countTotalArr+1)).find('.health-text').slideDown('fast');
                    $('#pos-'+(countTotalArr+1)).find('.block-head ').addClass('block-open');
                  }
          		}
          }else{
            if ($(obj).hasClass('block-open')) {
              
              $(obj).removeClass('block-open');
              $(obj).parent().find('.health-text').hide();
              
              
              if ($('#pos-'+(countTotalArr-1)).length) {
                	$('#pos-'+(countTotalArr-1)).find('.block-head ').removeClass('block-open');
                    $('#pos-'+(countTotalArr-1)).find('.health-text').hide();
                  }
              
            }else{
               $(obj).addClass('block-open');
               $(obj).parent().find('.health-text').slideDown('fast');             
              
              if ($('#pos-'+(countTotalArr-1)).length) {
                $('#pos-'+(countTotalArr-1)).find('.health-text').slideDown('fast');
                $('#pos-'+(countTotalArr-1)).find('.block-head ').addClass('block-open');
              }
          	}
          }
        }
    })
}
function activateCollapseProd() {
  
}
function activateCollapseProd() {
  
    $(document).ready(function() {
   		if ($(window).width() < 768) {
  
          	$(document).on('click', '.section-close .title', function (event) {
              $(this).toggleClass( 'section-open'); 
  
              $(this).parent().find('.for-open').fadeToggle( "fast", function() {
                	
              });
            });
        }
    })
}
function activateSlickInProd(){
  
  if (!$('.thumbnails-wrapper').length) {
    
    $('.product-single__media-wrapper').show();    
    return;
  }
  
  $(document).ready(function() {
   
     if(typeof product_image_count !== "undefined" && product_image_count && $(window).width() > 1024) {
       $('.init_slick_slider').on('init', function() {
         $('.init_slick_slider').css('opacity', '1');
         console.log('show');
       })
        
       $('.init_slick_slider').not('.slick-initialized').slick({
                    
          draggable:true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
             responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }    

            ]
        });
       

       $('.init_slick_slider').on('afterChange', function(event, slick, currentSlide){                 
        
         setTimeout(() =>  $('.init_slick_slider').find('.slick-current a').click(), 500);
       });
     }
	
   if ($(window).width() < 1025 ) {
     
        if ($('.product-single__thumbnails').hasClass('slick-initialized')) {
              $('.product-single__thumbnails').slick('unslick');
      	}
       // $('.product-single__thumbnails').attr('href',"#");
     	$('.product-single__thumbnails-item a').on( "click", function(event) {
          return false;
     	})
     	//$('.product-single__thumbnails-item a').attr('href',"#");
    
        $('.thumbnails-wrapper').show();
        $('.product-single__media-wrapper').hide();
       $('.product-single__thumbnails').find('[data-slick]').each(function() {
         
         let newSrc = $(this).attr('data-slick');         
         $(this).attr('src',newSrc);         
         
       });
     
     

           
         $('.product-single__thumbnails').not('.slick-initialized').slick({
                    
          draggable:true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000,
             responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }    

            ]
        });
      } else {
         $('.product-single__thumbnails').find('[data-slick]').each(function() {

           let newSrc = $(this).attr('data-small');           
           $(this).attr('src',newSrc);
           

         });
     
          $('.thumbnails-wrapper').find('a').off( "click");
          $('.thumbnails-wrapper').find('a').on( "click", function(event) {
            event.stopPropagation();
            event.preventDefault();
            $('.thumbnails-wrapper').find('a').removeClass('active-thumb');
            $(this).addClass('active-thumb');
            $(this).attr('aria-current', true);
            let curHref = $(this).attr('href');
            //console.log($('.product-single__media'));
            $('.product-single__media').find('img').attr('srcset','').attr('src',curHref);
           /* $('.product-single__media').find('img').animate({
              opacity: 0, 
            },100, "linear", function(){
              $( this ).attr('srcset','').attr('src',curHref);
              $( this ).animate({
                opacity: 1,
              },100, "linear", function() {        
              });
            });
            */
            return false;
          });
       }
  });
}
$('form button.btn-now').click(function(){
$(this).addClass('active');
});
function addNewProdCart(event,url) {
  event.stopPropagation(); 
  addNewProd(url, function(){
    setTimeout(() => $('.product-form__cart-submit').click(), 10);        
  });
}
function byuNowClick(obj,id){
  event.preventDefault(); 
  event.stopPropagation(); 
  
  let url = $(obj).attr('href');
  let link = '/cart/'+id + ':1';
  history.replaceState({page: 'back'}, 'Cart',window.location.origin+"/cart");

  $.ajax(
            link, 
            {
                success: function(data) {
                 window.location.href = url;
                },
                error: function() {
                  //alert('There was some error performing the AJAX call!');
                }
             }
          );
}

function changeTab(obj) {

  $('.page-product-block').removeClass('active-block');
  let nameBlock =  $(obj).attr('data-type');

   $('.'+ nameBlock).addClass('active-block');
  
}

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;    

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  
  } else {  
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");
    
    function lazyload () {
      
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }    

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
        
      }, 5000);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
})
